// ** Redux & Store & Actions
import { useCallback, useContext, useMemo } from "react";
import { useSelector } from "react-redux";

// ** Third Party Components
import { useTranslation } from "react-i18next";

// ** Custom Components
import { CardWrapper } from "components/layout/Card/CardWrapper";
import { CardBody } from "components/layout/Card/CardBody";
import UserMediaUpgraded from "components/user/UserMediaUpgraded";
import LoadingContainer from "components/layout/LoadingContainer";
import { StyledUsersViewList } from "containers/Users/components/UsersViews/components/UsersViewList.styled";
import Loader, { StyledLoaderWrapperFullWidth } from "components/layout/Loader";

// ** Context
import deviceTypeContext from "contexts/deviceTypeContext";

// #####################################################

const UsersListSeo = ({ triggerRef, containerRef }) => {
	const { t } = useTranslation("common", "filtersAndSelectors");

	const usersListData = useSelector((state) => state.mainPageUsers.data);
	const isLoading = useSelector((state) => state.mainPageUsers.loading);
	const isLoaded = useSelector((state) => state.mainPageUsers.loaded);
	const usersPagination = useSelector(
		(state) => state.mainPageUsers.pagination
	);
	const vipProps = useMemo(() => {
		return {
			height: 17,
			marginBottom: 0.125,
			marginLeft: 0.5,
		};
	}, []);

	const { isPhone } = useContext(deviceTypeContext);

	const avatarProps = useMemo(() => {
		return {
			borderSize: true,
		};
	}, []);

	const renderUsersList = useCallback(() => {
		return usersListData.map((item) => {
			return (
				<UserMediaUpgraded
					key={item.id}
					user={item}
					smallOnMobile={false}
					avatarProps={avatarProps}
					maxWidthWithEllipsis={!isPhone && 400}
					vipProps={vipProps}
				/>
			);
		});
	}, [usersListData]);

	// #####################################################

	return (
		<>
			{!isLoading && isLoaded && usersListData?.length === 0 && (
				<CardWrapper>
					<CardBody>
						<LoadingContainer
							loading={isLoading}
							empty={isLoaded && usersListData.length === 0}
							noContentText={t(
								"filtersAndSelectors:noResultsText"
							)}
							loaderDefault
						/>
					</CardBody>
				</CardWrapper>
			)}

			<StyledUsersViewList ref={containerRef}>
				{usersListData?.length > 0 && renderUsersList()}
				{isLoading && (
					<CardWrapper>
						<CardBody>
							<StyledLoaderWrapperFullWidth noMargin>
								<Loader />
							</StyledLoaderWrapperFullWidth>
						</CardBody>
					</CardWrapper>
				)}
				{!isLoading &&
					!(
						usersPagination?.currentpage > 0 &&
						usersListData?.length === 0
					) && (
						<div
							ref={triggerRef}
							style={{
								height: "1px",
								pointerEvents: "none",
							}}
						/>
					)}
			</StyledUsersViewList>
		</>
	);
};

// #####################################################

export default UsersListSeo;

// #####################################################
